import { createSlice,createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"

const initState = {
    isLoading:false,
    message:'',
    users:[]
}

export const fetchUser = createAsyncThunk('users/getUser', async () => {
      const response = await axios.get("https://jsonplaceholder.typicode.com/users")
      return response.data
    })


let userSlice = createSlice({
    name:'user',
    initialState:initState,
    extraReducers:(builder)=>{
        builder
        .addCase(fetchUser.pending,(state)=>{
            state.isLoading = true
        })
        .addCase(fetchUser.fulfilled,(state,action)=>{
           // console.log(action.payload)
            state.isLoading = false
            state.users = action.payload
        })
        .addCase(fetchUser.rejected,(state,payload)=>{
            state.isLoading = false
            state.message = "error"
        })

    },
    reducers:{
        increment : function(state,action){
            state.count = state.count +1
        },
    
    }
})

//export const {} = userSlice.actions;

export default userSlice.reducer;